var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinStreamlinePixel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7551 8.38003V25.14H28.2851V8.38003H31.3251V6.86003H29.8051V5.33003H23.7051V2.28003H22.1851V5.33003H11.5151V2.28003H9.99512V5.33003H3.90512V6.86003H2.37512V8.38003H5.42512V25.14H6.94512V8.38003H26.7551Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7551 25.14H25.2351V29.71H26.7551V25.14Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2351 29.71H8.4751V31.24H25.2351V29.71Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7052 11.43H22.1852V23.62H23.7052V11.43Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1852 23.62H20.6652V26.66H22.1852V23.62Z",
    fill: "#000001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6151 11.43H16.0951V26.66H17.6151V11.43Z",
    fill: "#000001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1851 0.76001H11.5151V2.28001H22.1851V0.76001Z",
    fill: "#000001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0451 23.62H11.5151V26.66H13.0451V23.62Z",
    fill: "#000001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5151 11.43H9.99512V23.62H11.5151V11.43Z",
    fill: "#000001"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47507 25.14H6.94507V29.71H8.47507V25.14Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinStreamlinePixel);
export default __webpack_public_path__ + "static/media/bin--Streamline-Pixel.bffcab119bfd9757f4e7fab0089cf105.svg";
export { ForwardRef as ReactComponent };